/**
 * @module nhcweb/apps/shared/nhc-modules/map-popups
 */
import './map-popups.css';
import Overlay from 'ol/Overlay.js';
// Depends on jquery, jquery-ui and pagination.js being installed


export class PopupOverlay extends Overlay {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};
    options.positioning = "bottom-left";
    options.offset = [-50, -15];
    // The element that will contain the control needs to be created here
    // and passed to the parent constructor.
    options.element = document.createElement('div');
    super(options);

    this.options = options;

    // Create the inner-most divs (including the hr div)
    this.popupData = document.createElement('div');
    this.popupData.id = 'popup-data';
    this.hr = document.createElement('hr');
    this.popupPagination = document.createElement('div');
    this.popupPagination.id = 'popup-pagination';

    // Create the content div and append its child elements
    this.popupContent = document.createElement('div');
    this.popupContent.id = 'popup-content';
    this.popupContent.appendChild(this.popupData);
    this.popupContent.appendChild(this.hr);
    this.popupContent.appendChild(this.popupPagination);

    // Create the anchor element
    this.popupCloser = document.createElement('a');
    this.popupCloser.href = '#';
    this.popupCloser.id = 'popup-closer';
    this.popupCloser.className = 'ol-popup-closer';

    // Create the main div and append its child elements
    // this.element = document.createElement('div');
    // Note: this.element is created when super(options) is called above
    this.element.id = 'popup';
    this.element.className = 'ol-popup';
    this.element.appendChild(this.popupCloser);
    this.element.appendChild(this.popupContent);

  }

  /**
   * Overriding the setMap method to add the event listeners. This ensures
   * that the event listeners are added after the control is added to the map.
   * @param {object} map 
   */
  setMap(map) {
    // Call the parent method.
    super.setMap(map);
  
    // Register the event handler if the map is not null.
    if (map) {
      // Display the popup when clicking on a feature
      map.on('singleclick', (event) => {
        this.displayFeatureInfo(map, event, this.options.labelSource);
      });
      // Close the popup when the close button is clicked
      this.popupCloser.addEventListener('click', (event) => {
        this.setPosition(undefined);
        this.popupCloser.blur();
        event.stopPropagation();
        event.preventDefault();
        return false;
      });
    }
  }

  /**
   * Display the feature info in the popup
   * @param {object} map The map object from the main map module
   * @param {object} event The event object from the map module
   * @param {object} checks The checks object from the main map module
   */
  displayFeatureInfo(map, event, checks) {
    // Close any existing overlay. If click is outside the region
    // this is faster than waiting to find out if there is a feature
    this.setPosition(undefined);

    const pixel = map.getEventPixel(event.originalEvent);
    const features = [];
    const sources = [];
    map.forEachFeatureAtPixel(pixel, (feature, layer) => {
      sources.push(this.getSourceLayer(layer, checks));
      features.push(feature);
    }, {
      layerFilter: function (layer) {
        return (typeof layer.getSource().url_ !== "undefined") ? true : false;
      },
    });

    if (features.length > 0) {
      const info = this.gatherInfo(features, sources);
      if (info.length > 0) {
        // Update content in your overlay
        $('#popup-pagination').pagination({
          dataSource: Object.values(info),
          pageSize: 1,
          showPageNumbers: false,
          showNavigator: true,
          callback: (data, pagination) => {
            // table closing tags are notably missing from the data
            if (data.includes("<table>") && !data.includes("</table>")) {
              var html = `<div>${data}</table></div>`;
            } else {
              var html = `<div>${data}</div>`;
            }
            $('#popup-data').html(html);
          }
        });
        this.setPosition(event.coordinate);
      }
    }
  };

  /**
   * Find the check.label string that corresponds to the layer using 
   * the idStr and the filename
   * @param {object} layer
   * @param {object} checks The checks object from the main map module
   * @returns {string} The check.labelShort string
   */
  getSourceLayer(layer, checks) {
    let fileOnly = layer.getSource().url_.split('/').pop();
    for (let [key, check] of Object.entries(checks)) {
      if (fileOnly.includes(check.idStr)) {
        return check.labelShort;
      }
    }
    return "";
  }

  /**
   * Gather the info from the features and sources
   * @param {object} features 
   * @param {array} sources 
   * @returns 
   */
  gatherInfo(features, sources) {
    const info = [];
    let i, ii;
    for (i = 0, ii = features.length; i < ii; ++i) {
      let description =
        features[i].get('description') ||
        features[i].get('name') ||
        features[i].get('_name') ||
        features[i].get('layer');
      if (description) {
        description = `<div><b>Source Layer:</b> ${sources[i]}</div><hr>${description}`;
        info.push(description);
      }
    }
    return info;
  }

}


